import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './academy.css'
import { useHistory } from 'react-router-dom';
import { Tooltip } from 'react-tooltip'
const Academy = () => {
    const bgImage = "url('./assets/images/BgImage.jpg')";
    const backIcon = "/assets/images/icons8-back-64.png";
    const checkIcon = "/assets/images/icons8-check-96.png";

    const [modules, setModules] = useState([]);
    let history = useHistory();
    useEffect(() => {
        // Fetching data on component mount
        var pId = localStorage.getItem('MT_ID');
        fetch(`/api/Course/GetModules/${pId}`)
            .then(response => response.json())
            .then(data => setModules(data))
            .catch(error => console.error('Error fetching data:', error));
    }, []);
    function handleClick(module) {
        if (!module.disabled) {
            history.push(`/module/${module.moduleId}`);
        }
    }

    return (
        <div className="bgStyle" style={{ backgroundImage: bgImage }}  >
            <a href='/'>
                <img src={backIcon} alt="" width='50' height='50' style={{ position: 'fixed', top: '30px', left: '30px' }} />
            </a>
            <Tooltip id="my-tooltip" className="react-tooltip" place="top" type="dark" effect="solid" />
            <h1 className='titleStyle mb-4 mt-4'>Cancer Management Learning Program</h1>
            {/* Iterate over the modules and render each module's details inside a containerBox */}
            {modules.map(module => (
                <div key={module.moduleId} style={{ cursor: 'pointer', position: 'relative' }} onClick={(e) => handleClick(module)} className="containerBox mt-3" >
                    {module.disabled ? (
                        <div className="playButton mt-3" data-tooltip-id="my-tooltip" data-tooltip-content="Module Locked: Complete Previous Module & Wait for Previous Month's Duration">
                            <img height={'70px'} width={'70px'} src="./assets/images/icons8-play-disabled-96.png" alt="Play Button" />
                        </div>
                    ) : (
                        <Link to={`/module/${module.moduleId}`}>
                            <div className="playButton mt-3" title="Click to Play!">
                                <img height={'70px'} width={'70px'} src="./assets/images/icons8-play-96.png" alt="Play Button" />
                            </div>
                        </Link>
                    )}
                    {/* <Link to={`/module/${module.moduleId}`}>
                        <div className="playButton mt-3">
                            <img height={'70px'} width={'70px'} src="./assets/images/icons8-play-96.png" alt="Play Button" />
                        </div>
                    </Link> */}
                    <div className='headingSection mt-4'>
                        <h5>Module {module.moduleNumber + ' - ' + module.moduleName}</h5>
                        <p className='moduleDescription' style={{ width: '85%' }}>
                            {module.description}
                        </p>
                    </div>
                    <div className="bottomText">{module.percentComplete}% Completed</div>
                    {module.moduleComplete && <img height='50' width='50' style={{ position: 'absolute', top: '34px', right: '8px' }} src={checkIcon} alt="" />}
                </div>
            ))}
        </div>
    );
}

export default Academy;